module.exports = __webpack_public_path__ + "static/img/logo.8218f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = 148
// module chunks = 1